module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"maxVacanciesTitleCopy":"Вы не можете скопировать вакансию","vacancy":"Вакансия","city":"Город","candidates":"Кандидаты","interview":"Интервью","expires":"Истекает","noData":"Нет данных","testing":"Тестирование","creator":"Создатель","newVacancy":"Новая вакансия"}}')
  delete Component.options._Ctor
}
